let language = {
    ORDER_BILL_TOTAL_WEIGHT: "Total weight:",
    ORDER_BILL_SUBTOTAL: "Subtotal:",
    ORDER_BILL_TAX: "Tax:",
    ORDER_BILL_SHIPPING_FEE: "Shipping:",
    ORDER_BILL_IMPORT_SERVICE_FEE: "Import Service:",
    ORDER_BILL_TOTAL: "Total Due:",
};

export { language }